import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["resourceTypeInput", "resourceSelect"]
  static values = { resourceUrls: Object }

  connect() {
    this.initializeAllResourceInputs()
  }

  updateResourceInput(event) {
    const resourceTypeInput = event.target
    const row = resourceTypeInput.closest(".nested-form-container")
    if (!row) return

    const resourceSelect = row.querySelector('[data-admin--stripe-payments--form-target="resourceSelect"]')
    if (!resourceSelect) return

    // Update AJAX URL
    const type = resourceTypeInput.value?.[0]?.value || resourceTypeInput.value
    const url = this.resourceUrlsValue[type]
    if (resourceSelect["form--collection-select--component"]) {
      resourceSelect["form--collection-select--component"].setAjaxUrl(url)
      resourceSelect["form--collection-select--component"].clearValue()
    } else {
      resourceSelect.dataset.ajaxUrl = url
    }
  }

  initializeAllResourceInputs() {
    this.resourceTypeInputTargets.forEach(resourceTypeInput => {
      this.updateResourceInput({ target: resourceTypeInput })
    })
  }

  flowChanged(event) {
    const flowKey = event.target.value[0].value;
    const paymentId = this.element.dataset.paymentId;
    let url;
    let r_url;
    if (paymentId && paymentId !== "") {
      url = `/oqoro_admin/stripe_payments/${paymentId}/metadata_fields?flow_key=${encodeURIComponent(flowKey)}`;
      r_url = `/oqoro_admin/stripe_payments/${paymentId}/resources_fields?flow_key=${encodeURIComponent(flowKey)}`;
    } else {
      url = `/oqoro_admin/stripe_payments/metadata_fields?flow_key=${encodeURIComponent(flowKey)}`;
      r_url = `/oqoro_admin/stripe_payments/resources_fields?flow_key=${encodeURIComponent(flowKey)}`;
    }

    const frame = document.getElementById("stripe-payment-metadata-fields");
    if (frame) frame.src = url;
    const r_frame = document.getElementById("stripe-payment-resources-fields");
    if (r_frame) r_frame.src = r_url;
  }
}
